import PropTypes from 'prop-types';
import { Flex } from '@rebass/grid';

import { ConnectedModal } from 'app/shared/modules/overlay/defaultOverlays/modal/Modal';

import {
  ImageWrapperSt,
  SuccessTextSt,
  ButtonSt,
} from './MobileSuccessModal.css';

export const MobileSuccessModal = ({ closeOverlay, successTranslations }) => {
  return (
    <ConnectedModal ariaLabel="crm subscription modal" title="">
      <Flex justifyContent="center" flexDirection="column">
        <ImageWrapperSt>
          <img src="/assets/mailtrain/subscription.svg" alt="" />
        </ImageWrapperSt>
        <SuccessTextSt>{successTranslations.successMessage}</SuccessTextSt>
      </Flex>
      <ButtonSt width={1} onClick={closeOverlay}>
        {successTranslations.closeButton}
      </ButtonSt>
    </ConnectedModal>
  );
};

export const successTranslationsShape = PropTypes.shape({
  successMessage: PropTypes.object,
  closeButton: PropTypes.object,
});

MobileSuccessModal.propTypes = {
  closeOverlay: PropTypes.func.isRequired,
  successTranslations: successTranslationsShape.isRequired,
};
